export default "__VITE_PUBLIC_ASSET__1700ba74__"